import React, {ReactNode} from 'react';
import classNames from 'classnames';
import styles from './CLSpinner.module.scss';
import CLMaskIcon from '../CLMaskIcon/CLMaskIcon';
import iconsObj from '../../assets/icons/iconsObj';
import {AutomationProps} from 'common/src/modules/automation/automation.types';
import addAutomationTag from 'common/src/modules/automation/utils/addAutomationTag';
export interface SpinnerProps extends AutomationProps {
  message?: ReactNode;
  className?: string;
  spinnerClassName?: string;
  messageClassName?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  orientation?: 'row' | 'column' | 'column-reverse';
  centerInContainer?: boolean;
}

const CLSpinner: React.FC<SpinnerProps> = ({
  message,
  size = 'sm',
  orientation = 'row',
  className = '',
  spinnerClassName = '',
  messageClassName = '',
  centerInContainer,
  qaHook = '',
}: SpinnerProps) => {
  return (
    <div
      {...addAutomationTag(qaHook)}
      className={classNames(styles.common_cl_spinner, styles[orientation], className, {
        [styles.full_height]: centerInContainer,
      })}
    >
      <CLMaskIcon
        src={iconsObj.spinner}
        className={classNames(styles[size], spinnerClassName, styles.spinner_icon)}
      />
      {message && (
        <span className={classNames(messageClassName, styles.spinner_message)}>{message}</span>
      )}
    </div>
  );
};

export default CLSpinner;
